import "@fortawesome/fontawesome-free/css/all.min.css";
import "bootstrap-css-only/css/bootstrap.min.css";
import "mdbvue/lib/css/mdb.min.css";

import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import i18n from "./lang/lang";

Vue.config.productionTip = false;

import axios from "axios";
import VueAxios from "vue-axios";

import VueMeta from "vue-meta";
Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true
});

import Notify from "mdbvue/lib/components/Notify";
Vue.use(Notify);

import VuePapaParse from "vue-papa-parse";
Vue.use(VuePapaParse);

import VueGlobalVar from "vue-global-var";
Vue.use(VueGlobalVar, {
  globals: {
    $sessionId: String,
    $username: String
  }
});

import VueLuxon from "vue-luxon";
Vue.use(VueLuxon);

import "@/mixins/Helpers.js";

// Import and register global enums
import * as Enums from "@/constants/enums.js";
Vue.prototype.$enums = Enums;

var SERVER_NAME = "https://csbackendrd.virabeli.fi/api";
if (window.location.hostname.includes("csfrontendrd"))
  SERVER_NAME = "https://csbackendfrontrd.virabeli.fi/api";
else if (window.location.hostname.includes("backend"))
  SERVER_NAME = "https://csbackend.virabeli.fi:8081/api";
else SERVER_NAME = "http://127.0.0.1:5000/api"; // for local hosting
//else SERVER_NAME = "https://csbackend.virabeli.fi:8081/api";
var ANALYTICS_URL = "https://logger.virabeli.fi/";

Vue.prototype.$httpAnalytics = axios.create({
  baseURL: ANALYTICS_URL,
  withCredentials: false,
});

axios.defaults.baseURL = SERVER_NAME;
axios.defaults.withCredentials = false;
axios.defaults.headers['Content-Type'] = 'application/json';

Vue.use(VueAxios, axios );


const moment = require("moment");

if (navigator.language.startsWith("fi")) {
  require("moment/locale/fi");
} else {
  require("moment/locale/es-us");
}

Vue.use(require("vue-moment"), {
  moment,
});

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");
